import { Amplify } from 'aws-amplify';
import 'aws-amplify/auth/enable-oauth-listener';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';

const cognitoDomain = (import.meta.env.VITE_COGNITO_DOMAIN || '').replace(/^https?:\/\//, '');

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
      loginWith: {
        oauth: {
          domain: cognitoDomain,
          providers: ['Google' as const],
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: [window.location.origin + '/auth/callback'],
          redirectSignOut: [window.location.origin + '/login'],
          responseType: 'code' as const,
        },
      },
    },
  },
};

export const configureAuth = () => {
  Amplify.configure(awsConfig);
};

export const getAuthToken = async () => {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString();
  } catch (error) {
    return null;
  }
};

export const getUser = async () => {
  try {
    return await getCurrentUser();
  } catch (error) {
    return null;
  }
};

